export default [
    'Bridge',
    'Conventional',
    'SBA',
    'Construction',
    'Private Financing',
];
